import React, { useEffect, useState } from "react";
import { Button, Drawer, Box } from "@mui/material";
import { useRouter } from "../../../utils/hooks/useRouter";
import { firebaseAndKvaLog } from "../../../services/analytics/analytic.service";
import { getKVWebUrl } from "../../../services/domain/domainSetting.service";

export default function BottomSheetPublishWebsite({
  openBottemSheetWelcome,
  setOpenBottemSheetWelcome,
  merchantInfo,
  isWebView,
}: {
  openBottemSheetWelcome: boolean;
  setOpenBottemSheetWelcome?: any;
  merchantInfo: IRetailMerchantInfo | undefined;
  isWebView?: boolean;
}) {
  const router = useRouter();
  const { code } = router.query;
  const [link, setLink] = useState("");
  useEffect(() => {
    setLink(getKVWebUrl(merchantInfo));
  }, [merchantInfo]);

  const handleViewWebsite = () => {
    (window as any).openMyWebsite(link, "retail");
    if (!isWebView) {
      window.location.replace(link);
    }
    firebaseAndKvaLog("retail", "kvapp_mk_setup_demo_viewweb");
  };

  const handleClickToSetting = () => {
    firebaseAndKvaLog("retail", "kvapp_mk_setup_demo_change");
    const url = `${process.env.REACT_APP_ADMIN_URL}/retail?code=${code}`;
    window.location.replace(url);
  };

  const handleCloseSheet = () => {
    firebaseAndKvaLog("retail", "kvapp_mk_setup_close");
    setOpenBottemSheetWelcome(false);
  };

  return (
    <>
      <Drawer
        anchor={"bottom"}
        open={openBottemSheetWelcome}
        onClose={() => setOpenBottemSheetWelcome(false)}
        PaperProps={{
          sx: {
            height: "100vh",
          },
        }}
      >
        <Box sx={{ position: "relative" }}>
          <img
            src={
              process.env.REACT_APP_ADMIN_URL + "/img/retail/BannerMobile.png"
            }
            alt=""
            width={"100%"}
          />

          <Box
            sx={{
              padding: "0 12px 70px 12px",
              marginTop: "24px",
              fontFamily: "Inter,sans-serif",
            }}
          >
            <Box
              sx={{
                fontWeight: 600,
                fontSize: "32px",
                lineHeight: "40px",
                width: "100%",
                textAlign: "center",
              }}
            >
              Chúc mừng
            </Box>

            <Box
              sx={{
                marginTop: "6px",
                textAlign: "center",
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: "500",
              }}
            >
              Website của bạn đã được xuất bản và đang hoạt động Online
            </Box>

            <Box
              sx={{
                display: "flex",
                padding: "4px 4px 4px 8px",
                gap: "9px",
                borderRadius: "4px",
                background: "#E5E7E9",
                marginTop: "28px",
                alignItems: "center",
              }}
            >
              <IconWebsiteUntouch />
              <Box
                sx={{
                  background: "white",
                  borderRadius: "4px",
                  flex: 1,
                  color: "#6F737E",
                  padding: "4px 32px 4px 4px",
                  fontSize: "14px",
                  lineHeight: "20px",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {link}
              </Box>
            </Box>
            <Box
              sx={{
                marginTop: "32px",
                display: "flex",
                gap: "24px",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  height: "1px",
                  background: "#E5E7E9",
                  width: "100%",
                  flex: 1,
                }}
              ></Box>
              <Box
                sx={{
                  color: "#E5E7E9",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: 500,
                  flex: 1,
                }}
              >
                Tiếp theo là gì
              </Box>
              <Box
                sx={{
                  height: "1px",
                  background: "#E5E7E9",
                  width: "100%",
                  flex: 1,
                }}
              ></Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: "16px",
                marginTop: "24px",
              }}
            >
              <Box>
                <img
                  src={
                    process.env.REACT_APP_ADMIN_URL +
                    "/img/retail/PublishImageDesc.png"
                  }
                  alt=""
                  width={"70px"}
                />
              </Box>
              <Box>
                <Box
                  sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "#323741",
                  }}
                >
                  Bạn có thể thay đổi thiết lập hiển thị giá bán
                </Box>
                <Box
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "#323741",
                    marginTop: "4px",
                  }}
                >
                  Với thiết lập hiển thị giá bán. Bạn có thể để bảng giá chung
                  hoặc giá Khuyến mại cho sản phẩm
                </Box>
                <Box
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "#0070F4",
                    marginTop: "14px",
                    cursor: "pointer",
                    width: "fit-content",
                  }}
                  onClick={handleClickToSetting}
                >
                  Thay đổi ngay
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              bottom: 0,
              position: "fixed",
              zIndex: 3,
              width: "100%",
              padding: "8px 12px",
              boxShadow:
                "0px -13px 24px 4px rgba(0, 0, 0, 0.03), 0px -2px 10px rgba(0, 0, 0, 0.03)",
            }}
          >
            <Button
              size="large"
              variant="contained"
              sx={{
                boxShadow: "none",
                padding: "10px 0",
                borderRadius: "12px",
                background: "#0070F4",
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "20px",
                color: "white",
                width: "100%",
              }}
              onClick={handleViewWebsite}
            >
              <div>Xem website</div>
            </Button>
          </Box>
          <Box
            sx={{
              position: "absolute",
              top: "12px",
              right: "12px",
              cursor: "pointer",
            }}
            onClick={handleCloseSheet}
          >
            <IconClose />
          </Box>
        </Box>
      </Drawer>
    </>
  );
}

export function IconWebsiteUntouch() {
  return (
    <svg
      width="43"
      height="19"
      viewBox="0 0 43 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6407 8.67022H6.23869L9.90939 4.99951C10.2027 4.70616 10.2027 4.22476 9.90939 3.9314C9.83981 3.86167 9.75715 3.80635 9.66615 3.7686C9.57516 3.73085 9.47761 3.71143 9.3791 3.71143C9.28058 3.71143 9.18304 3.73085 9.09204 3.7686C9.00105 3.80635 8.91839 3.86167 8.8488 3.9314L3.89185 8.88835C3.82212 8.95794 3.7668 9.0406 3.72905 9.13159C3.6913 9.22259 3.67188 9.32013 3.67188 9.41865C3.67188 9.51716 3.6913 9.61471 3.72905 9.7057C3.7668 9.7967 3.82212 9.87936 3.89185 9.94894L8.8488 14.9059C8.91844 14.9755 9.00111 15.0308 9.0921 15.0685C9.18309 15.1062 9.28061 15.1256 9.3791 15.1256C9.47758 15.1256 9.5751 15.1062 9.66609 15.0685C9.75708 15.0308 9.83975 14.9755 9.90939 14.9059C9.97903 14.8363 10.0343 14.7536 10.072 14.6626C10.1097 14.5716 10.129 14.4741 10.129 14.3756C10.129 14.2771 10.1097 14.1796 10.072 14.0886C10.0343 13.9976 9.97903 13.9149 9.90939 13.8453L6.23869 10.1746H14.6407C15.0544 10.1746 15.3929 9.83612 15.3929 9.42241C15.3929 9.0087 15.0544 8.67022 14.6407 8.67022Z"
        fill="#9C9C9C"
      />
      <g clipPath="url(#clip0_1_30638)">
        <path
          d="M37.5345 14.0211C36.4719 15.0848 35.0734 15.7472 33.5772 15.8954C32.0811 16.0437 30.5798 15.6686 29.3291 14.834C28.0785 13.9995 27.1559 12.7572 26.7186 11.3187C26.2812 9.88022 26.3561 8.33459 26.9305 6.94515C27.505 5.55571 28.5434 4.40842 29.8689 3.69874C31.1943 2.98907 32.7249 2.76092 34.1997 3.05316C35.6745 3.34541 37.0024 4.13996 37.9571 5.30146C38.9118 6.46296 39.4342 7.91955 39.4354 9.42305H37.8107C37.8117 8.29532 37.4216 7.20214 36.7069 6.32979C35.9922 5.45743 34.9971 4.85989 33.8913 4.63898C32.7854 4.41807 31.6371 4.58746 30.6421 5.11829C29.6471 5.64911 28.867 6.50853 28.4347 7.55009C28.0023 8.59165 27.9445 9.75091 28.2711 10.8303C28.5977 11.9097 29.2885 12.8425 30.2257 13.4697C31.1629 14.0968 32.2887 14.3796 33.411 14.2698C34.5334 14.16 35.583 13.6644 36.3809 12.8675L37.5345 14.0211ZM35.3736 9.42305H41.8725L38.623 12.6725L35.3736 9.42305Z"
          fill="#9C9C9C"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_30638">
          <rect
            width="16.2474"
            height="16.2474"
            fill="white"
            transform="translate(25.625 1.29932)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconClose() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9375 17.1484C18.2891 17.5391 18.2891 18.125 17.9375 18.4766C17.5469 18.8672 16.9609 18.8672 16.6094 18.4766L12 13.8281L7.35156 18.4766C6.96094 18.8672 6.375 18.8672 6.02344 18.4766C5.63281 18.125 5.63281 17.5391 6.02344 17.1484L10.6719 12.5L6.02344 7.85156C5.63281 7.46094 5.63281 6.875 6.02344 6.52344C6.375 6.13281 6.96094 6.13281 7.3125 6.52344L12 11.2109L16.6484 6.5625C17 6.17188 17.5859 6.17188 17.9375 6.5625C18.3281 6.91406 18.3281 7.5 17.9375 7.89062L13.2891 12.5L17.9375 17.1484Z"
        fill="white"
      />
    </svg>
  );
}
